import { useTranslation } from 'react-i18next'

import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react'

import { Button } from '@reveni-io/reveni-ui'

import useTimeline from './hooks/useTimeline'
import TimelineDateGroup from './TimelineDateGroup/TimelineDateGroup'
import { groupEventsByDate } from './helpers'
import * as Styles from './styles'

const Timeline = ({ timeline, timezone }) => {
  const { isExpanded, handleToggle, contentRef } = useTimeline()
  const { t, i18n } = useTranslation()

  if (!timeline?.length) return null

  const groups = groupEventsByDate(timeline, i18n.language, timezone)

  return (
    <Styles.Container>
      <Styles.EventsContainer ref={contentRef} collapsed={!isExpanded} height={contentRef.current?.scrollHeight || 100}>
        {groups.map(group => (
          <TimelineDateGroup key={group.date} label={group?.label} events={group?.events} />
        ))}
      </Styles.EventsContainer>
      <Button variant="text" onClick={handleToggle}>
        {isExpanded ? t('Ocultar historial') : t('Mostrar historial completo')}
        {isExpanded ? <CaretUpIcon size={16} /> : <CaretDownIcon size={16} />}
      </Button>
    </Styles.Container>
  )
}

export default Timeline
